var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"text-h4 mb-10"},[_vm._v("Perfil de Usuário")]),_c('CardUserPerfil')],1)}
var staticRenderFns = []

export { render, staticRenderFns }